import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {RouteEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";

export type RouteAction =
  "EDIT_WATER_DEL_SITE_ASSIGNMENT"
  | "EDIT_WATER_COMPANY_SITE_ASSIGNMENT"
  | "EDIT_OIL_DEL_SITE_ASSIGNMENT"
  | "EDIT_OIL_COMPANY_SITE_ASSIGNMENT"

export type RouteActionMenuDropdownProps = {
  route: RouteEntity
  onActionClick?: (action: RouteAction) => void
}

export const RouteActionMenuDropdown = (props: RouteActionMenuDropdownProps) => {
  const {route, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<RouteAction> = useMemo(() => {
    const actions = new Set<RouteAction>()
    if (hasAccess("route_edit", "siteassignment_edit")) {
      if (hasAccess("siteassignmentsiteassoc_create", "siteassignmentsiteassoc_edit")) {
        actions.add("EDIT_WATER_DEL_SITE_ASSIGNMENT")
        actions.add("EDIT_OIL_DEL_SITE_ASSIGNMENT")
      }
      if (hasAccess("siteassignmentcompanyassoc_create", "siteassignmentcompanyassoc_edit")) {
        actions.add("EDIT_WATER_COMPANY_SITE_ASSIGNMENT")
        actions.add("EDIT_OIL_COMPANY_SITE_ASSIGNMENT")
      }

    }
    return actions
  }, [route, hasAccess])

  const _onActionClick = useCallback((action: RouteAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT_WATER_DEL_SITE_ASSIGNMENT") &&
        <Menu.Item onClick={() => _onActionClick("EDIT_WATER_DEL_SITE_ASSIGNMENT")}>
          {t("common.action.edit.siteassignments.water", "Edit Water Delivery Site Assignments")}
        </Menu.Item>
      }
      {actions.has("EDIT_WATER_COMPANY_SITE_ASSIGNMENT") &&
        <Menu.Item onClick={() => _onActionClick("EDIT_WATER_COMPANY_SITE_ASSIGNMENT")}>
          {t("common.action.edit.companyassignments.water", "Edit Water Company Site Assignments")}
        </Menu.Item>
      }
      {actions.has("EDIT_OIL_DEL_SITE_ASSIGNMENT") &&
        <Menu.Item onClick={() => _onActionClick("EDIT_WATER_DEL_SITE_ASSIGNMENT")}>
          {t("common.action.edit.siteassignments.oil", "Edit Oil Delivery Site Assignments")}
        </Menu.Item>
      }
      {actions.has("EDIT_OIL_COMPANY_SITE_ASSIGNMENT") &&
        <Menu.Item onClick={() => _onActionClick("EDIT_OIL_COMPANY_SITE_ASSIGNMENT")}>
          {t("common.action.edit.companyassignments.oil", "Edit Oil Company Site Assignments")}
        </Menu.Item>
      }
    </>
  )
}
